import dayjs from "dayjs";
import {performGQL} from "../../../../../api-functions/functions";
import {v4} from "uuid";

const fragment = `
    id
    uploadID
    mortgageID
    name
    verifiedValue
    verifiedValueType
    verificationOn
    verificationBy
    supervisorCheckRequired
    supervisorCheckOn
    supervisorCheckBy
    createdAt
    _version
    _deleted
`
const createAdminMortgageUploadVerifiedPoint = /* GraphQL */ `
    mutation CreateAdminMortgageUploadVerifiedPoint(
        $input: CreateAdminMortgageUploadVerifiedPointInput!
        $condition: ModelAdminMortgageUploadVerifiedPointConditionInput
    ) {
        createAdminMortgageUploadVerifiedPoint(
            input: $input
            condition: $condition
        ) {${fragment}}
    }
`;
const updateAdminMortgageUploadVerifiedPoint = /* GraphQL */ `
    mutation UpdateAdminMortgageUploadVerifiedPoint(
        $input: UpdateAdminMortgageUploadVerifiedPointInput!
        $condition: ModelAdminMortgageUploadVerifiedPointConditionInput
    ) {
        updateAdminMortgageUploadVerifiedPoint(
            input: $input
            condition: $condition
        ) {${fragment}}
    }
`;

export const getClientValue = (dbValue, type, inExtWindow) => {

    switch (type) {
        case 'BOOLEAN':
            return ['TRUE', 'true'].includes(dbValue)
        case 'NUMBER':
            return parseFloat(dbValue)
        case 'date':
        case 'DATE':
            // if (inExtWindow) {
            //     return dbValue
            // }

            return !!dbValue ? dayjs.utc(dbValue, 'YYYY-MM-DD') : null
        case 'NULL':
            return null
        default:

            return dbValue
    }
}

export function getDBProps(clientValue, type) { //returns [dbValue, type]
    const dbTypes={
        currency: 'NUMBER',
        date: 'DATE',
        text: 'STRING',
        textarea: 'STRING',
        int: 'NUMBER',
        select: 'STRING',
        check: 'BOOLEAN',
    }
    const dbType =dbTypes[type]
    switch (dbType) {
        case 'DATE':
            if (!!clientValue) {
                if (typeof clientValue === 'string') {
                    clientValue = dayjs(clientValue, 'YYYY-MM-DD')
                }

                if (clientValue?.isValid()) {
                    return [clientValue.format('YYYY-MM-DD'), 'DATE']
                }
            }

            return [
                null, 'DATE'
            ]
        case 'NUMBER':
            return [
                clientValue ? clientValue.toString() : 0, 'NUMBER'
            ]
        case 'BOOLEAN':
            return [
                !clientValue ? "FALSE" : "TRUE", 'BOOLEAN'
            ]
        case 'STRING':
            return [
                clientValue ? clientValue.toString() : '', 'STRING'
            ]
        default:
            if (clientValue !== 0 && !clientValue) {
                return [
                    null, 'NULL'
                ]
            }
            if (typeof clientValue === 'number') {
                return [
                    clientValue.toString(), 'NUMBER'
                ]
            }
            if (typeof clientValue === 'boolean') {
                return [
                    !clientValue ? "FALSE" : "TRUE", 'BOOLEAN'
                ]
            }
            if (dayjs.isDayjs(clientValue)) {
                if (clientValue?.isValid()) {
                    return [
                        clientValue.format('YYYY-MM-DD'), 'DATE'
                    ]
                }
                return [
                    null, 'NULL'
                ]
            }
            if (typeof clientValue === 'string') {
                return [
                    clientValue, 'STRING'
                ]
            }
    }

}
export default class generalData {
    constructor({request, templateItem, uploadID, mortgageID, row}) {

        this.templateItem = templateItem
        this.uploadID = uploadID
        this.mortgageID = mortgageID
        this.request = request
        this.row = row
    }

    getClientValue = (inExtWindow)=> {
        if (!this.row) {
            return null
        }
        return getClientValue(this.row.verifiedValue, this.row.verifiedValueType, inExtWindow)
    }
    updateDB = async (dbValue, type) => {

        if (!this.row || !this.row.id) {
            this.row = {}
            return await performGQL({
                input: {
                    uploadID: this.uploadID,
                    mortgageID: this.mortgageID,
                    name: this.templateItem.name,
                    verifiedValue: dbValue,
                    verifiedValueType: type,
                    verificationOn: dayjs().toISOString(),
                    verificationBy: this.request.me.sub,
                    supervisorCheckBy: 'null'
                }
            }, createAdminMortgageUploadVerifiedPoint)
        }
        if (this.row.verifiedValue === dbValue && this.row.verifiedValueType === type) {
            return
        }
        const input = {
            verifiedValue: dbValue,
            verifiedValueType: type,
            verificationOn: dayjs().toISOString(),
            verificationBy: this.request.me.sub,
            id: this.row.id,
            uploadID: this.uploadID,
            _version: this.row._version
        }

        return await performGQL({input}, updateAdminMortgageUploadVerifiedPoint)
    }
    
    setValue = (clientValue) => {

        const [dbValue, type] = getDBProps(clientValue, this.templateItem.type);

        return this.updateDB(dbValue, type)
            .then(newDbRow => {
                this.row.verifiedValue = dbValue;
                this.row.verifiedValueType = type;
                this.row.verificationOn = dayjs().toISOString();
                this.row.verificationBy = this.request.me.sub;
                return newDbRow
            })
            .catch(err => {
                console.error("Error updating data point", err);
            });
    }

    formProps = (inExtWindow) => {
        return{
            templateItem: this.templateItem,
            clientValue: this.getClientValue(inExtWindow) ,
            setValue: this.setValue,
            inExtWindow
        }

    }
}